import Box from '@mui/material/Box';
import TopSection from './components/TopSection';
import BottomSection from './components/BottomSection';

const CommingSoon = ({ sectionName }) => {
    return (
        <Box sx={{ boxSizing: 'border-box', height: '100%', width: '100%' }}>
            <TopSection/>
            <BottomSection sectionName={sectionName}/>
        </Box>
    );
};

export default CommingSoon;
